import React, { useCallback } from 'react';
import * as Linking from 'expo-linking';
import { styled, SxProp, useSx } from 'dripsy';

import { BaseText, IBaseTextProps } from './BaseText';
import { IS_WEB } from '@utils';
import { SPACE_REGEXP, URL_REGEXP, HTTPS_REGEXP } from '@constants';

const baseLinkStyle: SxProp = {
  fontWeight: 'semi',
  textDecorationLine: 'underline',
};

const LinkTextTouchable = styled(BaseText)({
  ...baseLinkStyle,
});

const anchorStyle: SxProp = {
  ...baseLinkStyle,
  color: 'inherit',
};

function createUrl(item: string) {
  return !item.match(HTTPS_REGEXP) ? `https://${item}` : item;
}

export interface IRichTextProps extends IBaseTextProps {
  children: string;
}

export function RichText({
  style,
  children,
  ...props
}: IRichTextProps) {
  const sx = useSx();

  const renderChildren = useCallback(() => {
    return children.split(SPACE_REGEXP).map((item, index) => {
      const matchedItem = item.match(URL_REGEXP);

      if (matchedItem) {
        const url = createUrl(item);

        if (IS_WEB) {
          return (
            <a
              key={index}
              href={url}
              style={sx(anchorStyle)}
              target="_blank"
              // Prevent calling onClick/onPress in parent components
              onClick={(e) => e.stopPropagation()}
              rel="noreferrer"
            >
              {item}
            </a>
          );
        }

        return (
          <LinkTextTouchable
            onPress={() => Linking.openURL(url)}
            key={index}
            style={style}
          >
            {item}
          </LinkTextTouchable>
        );
      } else {
        return <BaseText key={index}>{item}</BaseText>;
      }
    });
  }, [children]);

  return (
    <BaseText style={style} {...props}>
      {renderChildren()}
    </BaseText>
  );
}
